import { DomSanitizer } from "@angular/platform-browser";
import { Injectable } from "@angular/core";
import { PruHttpService } from "./pru-http.service";
import { GenericService } from "./generic.service";
import { AggregationService } from "./aggregation.service";
import * as helpers from "../../mocks/helpers";
import { Initapp } from "../models/initapp/InitApp";
declare var window: any;
declare var environment: any;
@Injectable()
export class HomeinitService {
  appConfiguration: any;
  data: any;
  /** Start : Added for performance */
  appMessages: any;
  appOverlay: any;
  appEngagement: any;
  appData: any;
  initApp: Initapp;
  /** End: Added for performance */
  constructor(
    private PruHTTP: PruHttpService,
    // private _cookieService: CookieService,
    // tslint:disable-next-line:variable-name
    private _genericService: GenericService,
    private aggregationService: AggregationService,
    private _sanitizer: DomSanitizer
  ) { }
  /**
   * getLoadContent: Loads the content for the application.
   */

  getConfigService(): Promise<any> {
    let promise;
    //appconfig service
    const service = "/onprem/api/co/secure/authplatform/v3/appconfig?appname=home&rolecheck=true";

    promise = this.PruHTTP.getFullResponse(service, "HomeInItService")
      .toPromise()
      .then(loaddata => {
        if(loaddata.headers){
          try{
            if(loaddata.headers.get(environment.outageHeader)){
              this._genericService.outage = true;
            }
          }catch{
            console.log('Error getting appconfig resp header')
          }
        }
        this.appConfiguration = loaddata.body;
        // temp fix to handle cases where profile is null
        this.appConfiguration.profile = this.appConfiguration.profile || {};
        if (
          this.appConfiguration.responseCode === 403 ||
          this.appConfiguration.responseCode === "403"
        ) {
          this._genericService.callUiLogger(
            this.appConfiguration.responseStatus
          );
          return Promise.reject();
        } else if (
          this.appConfiguration.ddo &&
          this.appConfiguration.ddo.role
        ) {
          let stringifiedRole = JSON.stringify(this.appConfiguration.ddo.role);
          sessionStorage.setItem("userRoles", stringifiedRole);
          if (/INDV_AGG|INDV_CUSTOMER/i.test(stringifiedRole)) {
            return loaddata.body;
            // Commented this logic out as based on new approach cookie is being set by ApiGee

            // /**
            //  * If all the security steps have been followed, then the appconfig returns a token
            //  * which indicates the front end code to set the Device Validated cookie so that next time this service
            //  * is called, the cookie only is validated and the performace is better
            //  */
            // if (this.appConfiguration.token) {
            //   this._cookieService.set('DeviceValidated', this.appConfiguration.token, null, '/', '.prudential.com');
            // }
          } else {
            console.log("mfl redirect for role:", stringifiedRole);
            window.location.replace(environment.PUBLIC_RENDER_DOMAIN + "/mfl");
          }
        }
      })
      .catch(err => {
        let errormsg = err.error;
        console.log("Appconfig error: ", errormsg);
        if (errormsg.statusCode && errormsg.statusCode === 428) {
          if (
            errormsg.interstitials &&
            errormsg.interstitials.interceptor &&
            errormsg.interstitials.interceptor.url
          ) {
            console.log("Error 428 redirect to ", errormsg.interstitials.interceptor.url);
            window.location.href = errormsg.interstitials.interceptor.url;
          } else {
            window.location.href = "/iam/interstitial";
          }
          return Promise.reject();
        } else {
          this.appConfiguration = {
            appName: "fallback",
            domain: "https://www.prudential.com",
            buNames: []
          };
          sessionStorage.setItem(
            "userRoles",
            JSON.stringify(this.appConfiguration)
          );
        }
      });

    this._genericService.getToggleFeatures().subscribe((res: any) => {
      let redesign = false;
      if (res && res.length) {
        this._genericService.redesignFt1 = res.includes(environment.MKT_FEATURE_1)
        this._genericService.redesignFt2 = res.includes(environment.MKT_FEATURE_2)
        redesign = this._genericService.redesignFt1 || this._genericService.redesignFt2;
        this._genericService.redesign = redesign;
        this._genericService.toggleObs.next(redesign);
        this._genericService.toggleFeatures.next(res);
      }

    });


    return promise;
  }
}
